/**
 * Tagline block — scroll-triggered line-by-line reveal.
 *
 * Targets every `[data-tagline-block]` on the page (the page builder may
 * render zero, one, or multiple instances). Each instance gets its own
 * ScrollTrigger that fires once when the section enters the viewport.
 *
 * Honours prefers-reduced-motion by snapping lines to their final state.
 * Safe to call repeatedly (e.g. after Swup page:view) — GSAP overwrites the
 * existing tween targets and ScrollTrigger.refresh() in app.js handles
 * recalculation.
 */
export function initTagline(gsap, reducedMotion) {
    if (!gsap || !window.ScrollTrigger) return;

    const sections = document.querySelectorAll('[data-tagline-block]');
    if (!sections.length) return;

    sections.forEach((section) => {
        const lines = section.querySelectorAll('[data-tagline-line]');
        if (!lines.length) return;

        if (reducedMotion) {
            gsap.set(lines, { opacity: 1, y: 0 });
            return;
        }

        gsap.set(lines, { opacity: 0, y: 60 });

        gsap.to(lines, {
            opacity: 1,
            y: 0,
            duration: 0.9,
            stagger: 0.15,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: section,
                start: 'top 60%',
                once: true,
            },
        });
    });
}
